// Components
import FormButtons from '@/components/ui/FormButtons'
// Mixins
import uiMixin from '@/mixins/uiMixin'
// Vuex
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'PlaceReactivateSubscription',
  components: { FormButtons },
  mixins: [uiMixin],
  props: {
    // ID de la suscripción a dar de baja
    subscriptionId: {
      required: true,
      type: String,
      default: null
    },
    // ID de la suscripción en Stripe
    stripeSubscriptionId: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      formProcessing: false
    }
  },
  computed: {
    ...mapGetters('place', ['placeData'])
  },
  methods: {
    ...mapActions('place', ['reactivateSubscriptionInPlace']),
    /**
     * Pulsamos sobre el botón "Cancelar"
     */
    handleCancelButton() {
      this.hideDialog()
    },
    /**
     * Pulsamos sobre el botón "Aceptar"
     */
    async handleAcceptButton() {
      try {
        // Loading
        this.formProcessing = true
        // Reactivate subcription
        await this.reactivateSubscriptionInPlace({
          placeId: this.placeData.id,
          subscriptionId: this.subscriptionId,
          stripeSubscriptionId: this.stripeSubscriptionId
        })
        // show info
        this.modifyAppAlert({
          text: 'La suscripción se reactivo correctamente.',
          visible: true
        })
        // Cerramos modal
        this.hideDialog()
      } catch (error) {
        // Mensaje KO
        this.modifyAppAlert({
          text: error.message,
          type: 'error',
          visible: true
        })
      } finally {
        this.formProcessing = false
      }
    },
    /**
     * Hide dialog
     */
    hideDialog() {
      this.modifyAppDialog({
        visible: false
      })
    }
  }
}
